import createReactClass from "create-react-class";
import moment from "moment";
import React from "react";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { CurrentSchematic } from "../actions/compare/currentSchematic";
import { StageSchematic } from "../actions/compare/stageSchematic";
import { ServerActions } from "../actions/serverActions";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { compareDetailsStore } from "../stores/compareDetails";
import { formConversion } from "../util/formConversion";
import { formValidation } from "../util/formValidation";
import { ContentBox } from "./admin/ContentBox";
import "../css/adminScreen.css";
const { ActionTypes } = Constants;
var dataForIssuedTab;
var ifDataModified = false;

var data;
function getStateFromStores() {
  return {
    data: compareDetailsStore.getCompareList(),
    filteredData: compareDetailsStore.getCompareList(),
    loading: compareDetailsStore.compareListLoading(),

    disableHeader: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortDirection: SortDirection.ASC,
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
    previousSub: "",
    previousTab: "true",
  };
}

export const CompareList = createReactClass({
  componentDidMount: function () {
    compareDetailsStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    compareDetailsStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  onCompareRowClick: function (rowData) {
    rowData = rowData.rowData;
    //ServerActions.viewRequestHistory(rowData.syncId);

    console.log("open compare restriction");

    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    var openRestrictionServerRequest =
      ServerActions.openRequestOrRestrictionPromise(rowData.requestId);
    openRestrictionServerRequest.done(function (data) {
      if (data.success) {
        var form = formConversion.getClientFormat(data.data);

        if (data.data.restrictionDetail.type === Constants.RestrictionTypes.B) {
          if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
            dispatcher.dispatch({
              type: ActionTypes.OPEN_FORM_B_RESTRICTION,
              form: form,
            });
          } else {
            dispatcher.dispatch({
              type: ActionTypes.OPEN_FORM_B_REQUEST,
              form: form,
            });
          }
        } else if (
          data.data.restrictionDetail.type === Constants.RestrictionTypes.A
        ) {
          if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
            dispatcher.dispatch({
              type: ActionTypes.OPEN_FORM_A_RESTRICTION,
              form: form,
            });
          } else {
            dispatcher.dispatch({
              type: ActionTypes.OPEN_FORM_A_REQUEST,
              form: form,
            });
          }
        }

        if (form) {
          CurrentSchematic.openRestriction();
          StageSchematic.openRestriction();

          CurrentSchematic.centerAndZoom();
          StageSchematic.centerAndZoom();
        }
      }
    });

    this.setState({
      data: this.state.data,
      filteredData: this.state.data,
      loading: false,
    });

    //dispatcher.dispatch({
    //    type: ActionTypes.TOGGLE_COMPARE_LISTS
    //});
  },

  handleFilter: function (column, value, allFilterValues) {
    //reset data to original data-array

    data = this.state.data;

    //go over all filters and apply them
    Object.keys(allFilterValues).forEach(function (name) {
      var columnFilter = (allFilterValues[name] + "").toUpperCase();

      if (columnFilter == "") {
        return;
      }

      if (column.name == "syncId") {
        if (value.length > 4) {
          columnFilter = value.substring(2, value.length);
        }
      }

      (data = data.filter(function (item) {
        if ((item[name] + "").toUpperCase().indexOf(columnFilter) === 0) {
          return true;
        }
      })),
        (allFilterValues[name] = "");
    });

    this.setState({
      data: this.state.data,
      filteredData: data,
      loading: false,
    });
  },

  _sort: function ({ sortBy, sortDirection }) {
    window.searchSortActive = true;
    const comparer = (a, b) => {
      ifDataModified = true;
      if (sortBy == "tracks") {
        var a = a["tracks"].length > 1 ? "*Multiple*" : a["tracks"][0];
        var b = b["tracks"].length > 1 ? "*Multiple*" : b["tracks"][0];
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else {
        if (sortDirection === "ASC") {
          return a[sortBy] > b[sortBy] ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      }
    };
    var rows;
    if (ifDataModified) {
      rows = this.state.filteredData.sort(comparer);
    } else {
      rows = this.props.data.sort(comparer);
    }
    dataForIssuedTab = rows;
    this.setState({ filteredData: dataForIssuedTab });
    this.setState({ sortBy, sortDirection });
  },

  rowClassName: function ({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      var item = this.state.filteredData[index];
      var colorClass = "grayRow";
      switch (item.colorCode) {
        case "Red":
          colorClass = "redRow";
          break;
        case "Yellow":
          colorClass = "yellowRow";
          break;
        case "Green":
          colorClass = "greenRow";
          break;
      }
    }

    return colorClass;
  },

  _noRowsRenderer: function () {
    return <div className="issuedNoRows">No rows found</div>;
  },

  formatValue: function ({ cellData, dataKey, rowData }) {
    if (dataKey == "workStartMp") {
      return (
        formatMp(cellData) +
        (rowData.workStartMpSuffix ? rowData.workStartMpSuffix : "")
      );
    } else if (dataKey == "workEndMp") {
      return (
        formatMp(cellData) +
        (rowData.workEndMpSuffix ? rowData.workEndMpSuffix : "")
      );
    } else if (dataKey == "syncId") {
      return "GR" + rowData.syncId;
    } else if (dataKey == "tracks") {
      return renderTracks(rowData.tracks);
    } else if (dataKey == "effectiveTime") {
      return rowData.effectiveTime
        ? moment(rowData.effectiveTime).format("ddd MM/DD/YY HH:mm") +
            rowData.restrictionTimeZone
        : "";
    } else if (dataKey == "workStartDate") {
      return rowData.workStartDate
        ? moment(rowData.workStartDate).format("ddd HH:mm") +
            rowData.formBTimeZone +
            " " +
            moment(rowData.workStartDate).format("MM/DD/YY")
        : "";
    } else if (dataKey == "workEndDate") {
      return rowData.workEndDate
        ? moment(rowData.workEndDate).format("ddd HH:mm") +
            rowData.formBTimeZone +
            " " +
            moment(rowData.workEndDate).format("MM/DD/YY")
        : "";
    } else if (dataKey == "issueTime") {
      var value = rowData.issueTime;
      if (value != null && value.indexOf("/") > -1) {
        return value;
      } else {
        var m = moment(value, "YYYY-MM-DD HH:mm:ss");
        if (!m.isValid()) {
          return "N/A";
        }
        return m.format("MM/DD/YY ddd");
      }
    } else if (dataKey == "restrictionTimeZone") {
      var value = rowData.restrictionTimeZone;
      if (value != null && value.length == 6) {
        return value;
      } else {
        var m = moment(rowData.issueTime, "YYYY-MM-DD HH:mm:ss");
        if (!m.isValid()) {
          return "N/A";
        }
        rowData.restrictionTimeZone = m.format("HH:mm") + value;
        rowData.issueTime = m.format("MM/DD/YY ddd");
        return m.format("HH:mm") + value;
      }
    } else if (dataKey == "status") {
      return rowData.status.toUpperCase();
    }
  },
  render: function () {
    const {
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
      filteredData,
    } = this.state;
    var hig;
    if (screen.height <= 768) {
      hig = "72vh";
    } else {
      hig = "81vh";
    }

    return (
      <div style={{ height: "100%" }}>
        <ContentBox className="currentSchematic">
          <div style={{ height: hig }}>
            <AutoSizer>
              {({ height, width }) => (
                <Table
                  ref="Table"
                  disableHeader={false}
                  headerClassName="historyheaderColumn"
                  width={width}
                  height={height}
                  headerHeight={headerHeight}
                  rowHeight={rowHeight}
                  overscanRowCount={overscanRowCount}
                  rowCount={filteredData.length}
                  rowClassName={this.rowClassName}
                  sort={this._sort}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  noRowsRenderer={this._noRowsRenderer}
                  onRowDoubleClick={this.onCompareRowClick}
                  rowGetter={({ index }) => filteredData[index]}
                >
                  <Column
                    width={width * 0.25}
                    label="Subdivision"
                    dataKey="subdivision"
                  />
                  <Column width={width * 0.25} label="Type" dataKey="type" />
                  <Column
                    width={width * 0.25}
                    label="Restrn#"
                    dataKey="controlNumber"
                  />
                  <Column
                    width={width * 0.25}
                    label="GRIT Id"
                    dataKey="syncId"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="Status"
                    dataKey="status"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="From MP"
                    dataKey="workStartMp"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="To MP"
                    dataKey="workEndMp"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="Issued Date"
                    dataKey="issueTime"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="Issued Time"
                    dataKey="restrictionTimeZone"
                    cellRenderer={this.formatValue}
                  />
                  <Column
                    width={width * 0.25}
                    label="Tracks"
                    dataKey="tracks"
                    cellRenderer={this.formatValue}
                  />
                </Table>
              )}
            </AutoSizer>
          </div>
        </ContentBox>
      </div>
    );
  },
});

function formatMp(mp) {
  var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);

  if (mpRegexNoDecimal.test(mp)) {
    return mp + ".0";
  }
  return mp;
}

function renderTracks(value) {
  if (!Array.isArray(value)) return "";
  if (value.length > 1) {
    return <span title={value.join("\n")}>*Multiple*</span>;
  } else {
    return <span>{value[0]}</span>;
  }
}
